import "./style/index.css";
import Root from "./components/root";

export default Root;
